import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mappingOptions } from "src/utils/Api/modifyResponse";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";
import { IRI_PREFIX, mockData } from "src/utils/Company";

export default function useRentableGroups(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction: noFetching,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/rentable-groups",
          method: "GET",
          mockData,
        },
        mappingType: mappingOptions.byFrontendName,
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, noFetching, setData]);

  return data;
}
